import React, { lazy } from 'react';
const TOME_01_IMAGE = 'https://cdn.magicpatterns.com/uploads/tHTbuSBQCVzH6nBiegYNsp/hf_20260421_183420_fee5cfbd-7418-455c-9f0f-e928a88c4d3d.webp';
const TOME_02_IMAGE = 'https://cdn.magicpatterns.com/uploads/oKG5CuWxRUCvTwDfYb5XMp/hf_20260421_183606_78e23fc1-bcb3-4af9-9093-7ba39ad3cca2.webp';
const TOME_03_IMAGE = 'https://cdn.magicpatterns.com/uploads/4DFLTWcfcR5KHAfQyVcztA/hf_20260421_183657_b537c342-b120-4764-8f80-58ba2335a8fa.webp';
const TOME_04_IMAGE = 'https://cdn.magicpatterns.com/uploads/qm1Bu4VgTdH87pPaQdFEbw/hf_20260421_183624_a69cfdeb-95a7-42cd-b451-61cd31ca57ad.webp';
const TOME_05_IMAGE = 'https://cdn.magicpatterns.com/uploads/svPgm4gjAwwGjPGqPFUf8S/hf_20260421_183641_f569ea97-3b41-4393-ad6d-8e039810e680.webp';
const TOME_06_IMAGE = 'https://cdn.magicpatterns.com/uploads/wyVWnkexiZYv4JSFmKTjFU/hf_20260421_183725_1c00c9a1-9bfe-4350-b89a-a4291e820604.webp';
const tomes = [{
  label: 'Tomo 01',
  sublabel: 'Anatomía del Estancamiento',
  image: TOME_01_IMAGE
}, {
  label: 'Tomo 02',
  sublabel: 'Protocolo de Giro Inmediato',
  image: TOME_02_IMAGE
}, {
  label: 'Tomo 03',
  sublabel: 'Blindaje Emocional',
  image: TOME_03_IMAGE
}, {
  label: 'Tomo 04',
  sublabel: 'Casos Límite en Consultorio',
  image: TOME_04_IMAGE
}, {
  label: 'Tomo 05',
  sublabel: 'Psicología del Compromiso',
  image: TOME_05_IMAGE
}, {
  label: 'Tomo 06',
  sublabel: 'Sistema de Alta Complejidad',
  image: TOME_06_IMAGE
}];
const features = ['✅ Protocolos concretos para casos que no avanzan', '✅ +360 páginas listas para implementar hoy', '✅ Guiones, checklists y herramientas de intervención', '✅ Adaptado 100% al terapeuta argentino'];
export function ProductShowcase() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-261">
      <div className="mx-auto max-w-4xl text-center" data-id="element-262">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-violet-700 border border-violet-500/50 bg-violet-500/5 rounded-full px-4 py-1.5" data-id="element-263">
          🏆 El sistema de intervención clínica más completo para terapeutas en
          Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-violet-700 m-0 mb-4" data-id="element-264">
          MEGAPACK TERAPIA RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl mx-auto text-gray-800 m-0 mb-8 text-[14px]" data-id="element-265">
          <strong data-id="element-266">6 Tomos + 6 Bonos — El caso difícil resuelto.</strong>
          <br data-id="element-267" />
          +360 páginas · Anatomía del estancamiento · Protocolo de giro
          inmediato · Blindaje emocional · Casos límite · Retención de pacientes
          · Sistema de alta complejidad. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-268">
          <div className="grid grid-cols-3 sm:grid-cols-6 gap-3" data-id="element-269">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-270">
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-271">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-272" />
                </div>
                <div className="text-center" data-id="element-273">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-274">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-275">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-276">
            <div className="whitespace-nowrap bg-violet-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-277">
              6 TOMOS COMPLETOS · +360 PÁGINAS · ACCESO INMEDIATO
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-278">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-violet-500/5 border border-violet-500/20 rounded-xl px-4 py-3 text-left" data-id="element-279">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-violet-500/15 flex items-center justify-center" data-id="element-280">
                <svg className="w-3 h-3 text-violet-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-281">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-282" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-283">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}